import { markupReducers } from "./markup";
import { quantityReducers } from "./quantity";
import { visibilityReducers } from "./visibility";

export const stockPublicationReducers = {
  ...visibilityReducers,
  ...quantityReducers,
  ...markupReducers,
};
